import TextSetterMessaging from './TextSetterMessaging';

export default TextSetterMessaging;
